import { useReducer, useEffect, useRef } from 'react';

const initial_load = 'initial_load';
const load_more = 'load_more';
const on_error = 'on_error';

function reducer(state, action) {
  switch (action.type) {
    case initial_load: {
      let items = [...state.items];
      if (action.snapshot) {
        action.snapshot.forEach((doc) => {
          items.push({ id: doc.id, ...doc.data() });
        });
      }

      const nextLimit = items.length + action.limit;
      const end = items.length < action.limit || nextLimit === state.limit;

      return {
        ...state,
        hasMore: !end,
        limit: nextLimit,
        loading: false,
        lastLoaded:
          action.snapshot?.docs[action.snapshot?.docs.length - 1] ||
          state.lastLoaded,
        items,
      };
    }

    case load_more: {
      if (state.hasMore) {
        return {
          ...state,
          loading: true,
          triggerEffect: state.lastLoaded,
        };
      }
      return state;
    }
    case on_error:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

const initialState = {
  hasMore: false,
  triggerEffect: null,
  limit: 0,
  items: [],
  lastLoaded: null,
  loading: true,
  error: null,
  hasMounted: false,
};

export const usePaginateQuery = (value, { limit = 4 } = {}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { lastLoaded, hasMore, triggerEffect, error, items, loading } = state;

  const persisted = useRef(value);
  const lastVisible = useRef(lastLoaded);

  useEffect(() => {
    lastVisible.current = lastLoaded;
  }, [lastLoaded]);

  useEffect(() => {
    let isCancelled = false; 
    async function getData() {        
        let query;
        lastVisible.current
          ? (query = persisted.current
              .startAfter(lastVisible.current)
              .limit(limit))
          : (query = persisted.current.limit(limit));
        try {
          const snapshot = await query.get();
          if(!isCancelled) {
          dispatch({ type: initial_load, snapshot, limit });
          }
        } catch (err) {
          dispatch({ type: on_error, error: err.message });
        }
    }
    getData();
    return () => isCancelled = true;
  }, [triggerEffect, limit]);

  function loadMore() {
    dispatch({ type: load_more });
  }
  function reload() {
    dispatch({ type: initial_load });
  }

  return {
    loadMore,
    reload,
    error,
    loading,
    hasMore,
    items,
  };
};
